// -- Filters types - API values
export type ClientStatementViewTypes =
  (typeof ClientStatementViewType)[keyof typeof ClientStatementViewType]
export const ClientStatementViewType = {
  Summary: 'CLIENT_STATEMENT_TYPE_SUMMARY',
  Detailed: 'CLIENT_STATEMENT_TYPE_DETAILED',
} as const

export type ClientStatementDateFilters =
  (typeof ClientStatementDateFilter)[keyof typeof ClientStatementDateFilter]
export const ClientStatementDateFilter = {
  InvoiceIssuedDate: 'CLIENT_STATEMENT_DATE_FILTER_INVOICE_DATE',
  InvoiceDueDate: 'CLIENT_STATEMENT_DATE_FILTER_DUE_DATE',
} as const

// -- Filter types - URL params values
export type ClientStatementViewTypeParams =
  (typeof ClientStatementViewTypeParam)[keyof typeof ClientStatementViewTypeParam]
export const ClientStatementViewTypeParam = {
  Summary: 'SUMMARY',
  Detailed: 'DETAILED',
} as const

export type ClientStatementDateFilterParams =
  (typeof ClientStatementDateFilterParam)[keyof typeof ClientStatementDateFilterParam]
export const ClientStatementDateFilterParam = {
  InvoiceIssuedDate: 'ISSUED',
  InvoiceDueDate: 'DUE',
} as const

export type ClientStatementBalanceFilters =
  (typeof ClientStatementBalanceFilter)[keyof typeof ClientStatementBalanceFilter]
export const ClientStatementBalanceFilter = {
  BalanceSummary: 'SUMMARY',
  BalanceCurrent: 'CURRENT',
} as const

export type ClientStatementInvoicePaymentStatuses =
  (typeof ClientStatementInvoicePaymentStatus)[keyof typeof ClientStatementInvoicePaymentStatus]
export const ClientStatementInvoicePaymentStatus = {
  Paid: 'INVOICE_PAYMENT_STATUS_PAID',
  Unpaid: 'INVOICE_PAYMENT_STATUS_UNPAID',
  PartiallyPaid: 'INVOICE_PAYMENT_STATUS_PARTIALLY_PAID',
} as const

export const ClientStatementDateFieldKeyMap = {
  [ClientStatementDateFilter.InvoiceDueDate]: 'invoice_due_date',
  [ClientStatementDateFilter.InvoiceIssuedDate]: 'invoice_date',
} as const
